export default function TableSkeleton() {
  return (
    <div className="relative flex flex-col w-full h-full rounded-[16px]">
      <div className="rounded-tl-[16px] rounded-tr-[16px] overflow-x-auto">
        <div>
          <table className="w-full table-auto min-w-max text-center">
            <thead className="bg-[#1E3359]">
              <tr>
                <th className="p-4 border-b border-slate-600">
                  <div className="h-4 w-8 bg-slate-600/50 rounded animate-pulse" />
                </th>
                <th className="p-4 border-b border-slate-600">
                  <div className="h-4 w-24 bg-slate-600/50 rounded animate-pulse" />
                </th>
                <th className="p-4 border-b border-slate-600 hidden md:table-cell">
                  <div className="h-4 w-16 bg-slate-600/50 rounded animate-pulse" />
                </th>
                <th className="p-4 border-b border-slate-600 hidden md:table-cell">
                  <div className="h-4 w-28 bg-slate-600/50 rounded animate-pulse" />
                </th>
                <th className="p-4 border-b border-slate-600">
                  <div className="h-4 w-16 bg-slate-600/50 rounded animate-pulse" />
                </th>
              </tr>
            </thead>

            <tbody className="bg-white/5">
              {[...Array(5)].map((_, index) => (
                <tr key={index} className="hover:bg-slate-700/50">
                  <td className="p-4 border-b border-slate-700">
                    <div className="h-4 w-6 bg-slate-600/50 rounded animate-pulse mx-auto" />
                  </td>
                  <td className="p-4 border-b border-slate-700">
                    <div className="h-4 w-32 bg-slate-600/50 rounded animate-pulse mx-auto" />
                  </td>
                  <td className="p-4 border-b border-slate-700 hidden md:table-cell">
                    <div className="h-4 w-20 bg-slate-600/50 rounded animate-pulse mx-auto" />
                  </td>
                  <td className="p-4 border-b border-slate-700 hidden md:table-cell">
                    <div className="h-4 w-24 bg-slate-600/50 rounded animate-pulse mx-auto" />
                  </td>
                  <td className="p-4 border-b border-slate-700">
                    <div className="h-8 w-8 bg-slate-600/50 rounded-full animate-pulse mx-auto" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
